import { useIntl } from "react-intl";
import Badge from "components/v2/Badge/Badge";
import { summarizeQuotations } from "../../helpers/ShipmentQuotesV2Helpers";

interface QuotationTagsProps {
  quotation: any;
  quoteTags?: ReturnType<typeof summarizeQuotations>;
}

export default function QuotationTags({ quotation, quoteTags }: QuotationTagsProps) {
  const intl = useIntl();

  const isEarliest = quoteTags?.earliest?.reference === quotation.reference;
  const isFastest = quoteTags?.fastest?.reference === quotation.reference;
  const isCheapest = quoteTags?.cheapest?.reference === quotation.reference;
  const isLatest = quoteTags?.latest?.reference === quotation.reference;
  const isSlowest = quoteTags?.slowest?.reference === quotation.reference;
  const isHighestCost = quoteTags?.highestCost?.reference === quotation.reference;

  return (
    <div className="d-flex justify-content-end gap-sm">
      {isEarliest && (
        <Badge
          label={intl.formatMessage({
            id: "general.earliest",
            defaultMessage: "Earliest",
          })}
          color="success"
          type="status-badge"
        />
      )}
      {isFastest && (
        <Badge
          label={intl.formatMessage({
            id: "general.fastest",
            defaultMessage: "Fastest",
          })}
          color="success"
          type="status-badge"
        />
      )}
      {isCheapest && (
        <Badge
          label={intl.formatMessage({
            id: "general.cheapest",
            defaultMessage: "Cheapest",
          })}
          color="success"
          type="status-badge"
        />
      )}

      {isLatest && (
        <Badge
          label={intl.formatMessage({
            id: "general.latest",
            defaultMessage: "Latest",
          })}
          color="error"
          type="status-badge"
        />
      )}
      {isSlowest && (
        <Badge
          label={intl.formatMessage({
            id: "general.slowest",
            defaultMessage: "Slowest",
          })}
          color="error"
          type="status-badge"
        />
      )}
      {isHighestCost && (
        <Badge
          label={intl.formatMessage({
            id: "general.highestCost",
            defaultMessage: "Highest cost",
          })}
          color="error"
          type="status-badge"
        />
      )}
    </div>
  );
}

QuotationTags.defaultProps = {
  quoteTags: {},
};
